module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.50303317.png";